var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "before-close": _vm.handleClose,
        width: "520px"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _vm.contact && _vm.contact.origin !== "RISOLTO"
        ? [
            _c("el-alert", {
              attrs: {
                title: _vm.$t("warning"),
                type: "info",
                description: _vm.$t("ContactDialog.are_you_sure"),
                "show-icon": ""
              }
            }),
            _vm._v(" "),
            _c(
              "el-checkbox",
              {
                staticClass: "mt-5",
                model: {
                  value: _vm.form.copy_to_risolto,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "copy_to_risolto", $$v)
                  },
                  expression: "form.copy_to_risolto"
                }
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("ContactDialog.copy_to_risolto")) + " "
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "mt-20",
          attrs: { model: _vm.form, rules: _vm.rules }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("ContactDialog.firstName"),
                prop: "first_name"
              }
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("ContactDialog.firstName"),
                  disabled: _vm.disabled
                },
                model: {
                  value: _vm.form.first_name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "first_name", $$v)
                  },
                  expression: "form.first_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("ContactDialog.lastName"),
                prop: "last_name"
              }
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("ContactDialog.lastName"),
                  disabled: _vm.disabled
                },
                model: {
                  value: _vm.form.last_name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "last_name", $$v)
                  },
                  expression: "form.last_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("ContactDialog.locale"), prop: "locale" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("ContactDialog.locale"),
                    disabled: _vm.disabled
                  },
                  model: {
                    value: _vm.form.language,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "language", $$v)
                    },
                    expression: "form.language"
                  }
                },
                _vm._l(_vm.languages, function(item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: _vm.$translate.language(item), value: item }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("ContactDialog.contactType"),
                prop: "contact_type"
              }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    disabled: _vm.sortedContactTypes.length == 0,
                    clearable: "",
                    placeholder: _vm.$t("ContactDialog.contactType")
                  },
                  model: {
                    value: _vm.form.contact_type,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "contact_type", $$v)
                    },
                    expression: "form.contact_type"
                  }
                },
                _vm._l(_vm.sortedContactTypes, function(contact_type) {
                  return _c("el-option", {
                    key: contact_type.reference,
                    attrs: {
                      label: contact_type.contact_type,
                      value: contact_type.reference
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("shared.Cancel")))
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.handleFormSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("shared.Confirm")))]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }